import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import Cell from './Cell'

const Row = ({ time, cells, style }) => {
  const rowRef = useRef(null)
  const labelRefs = useRef([])
  const hasStickyLabels = cells.some(c => c.stickyLabel)

  useEffect(() => {
    if (!hasStickyLabels) return

    const row = rowRef.current
    if (!row) return

    const scrollContainer = row.closest('.rt-layout__timeline')
    if (!scrollContainer) return

    const cellPositions = cells.map(cell => {
      const s = time.toStyleLeftAndWidth(cell.start, cell.end)
      return {
        left: parseFloat(s.left),
        width: parseFloat(s.width),
      }
    })

    const handleScroll = () => {
      const scrollLeft = scrollContainer.scrollLeft
      cells.forEach((cell, i) => {
        if (!cell.stickyLabel || !labelRefs.current[i]) return
        const { left: cellLeft, width: cellWidth } = cellPositions[i]
        // follow scroll once cell's left edge goes off-screen
        const scrolled = Math.max(0, scrollLeft - cellLeft)
        const offset = Math.min(scrolled, cellWidth - 80)
        labelRefs.current[i].style.transform = `translateX(${offset}px)`
      })
    }

    scrollContainer.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => scrollContainer.removeEventListener('scroll', handleScroll)
  }, [cells, time, hasStickyLabels])

  return (
    <div className="rt-timebar__row" style={style} ref={rowRef}>
      {cells.map((cell, index) => (
        <Cell
          key={cell.id}
          time={time}
          {...cell}
          labelRef={cell.stickyLabel ? el => { labelRefs.current[index] = el } : undefined}
        />
      ))}
    </div>
  )
}

Row.propTypes = {
  time: PropTypes.shape({}).isRequired,
  cells: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  style: PropTypes.shape({}),
}

export default Row
